import { render } from "./list_user_search.vue?vue&type=template&id=33b97b56"
import script from "./list_user_search.js?vue&type=script&lang=js"
export * from "./list_user_search.js?vue&type=script&lang=js"

import "./list_user_search.vue?vue&type=style&index=0&id=33b97b56&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__